<template>
    <div class="col-11 col-md-7 col-lg-7 snackbar"
         v-if="propObj.isOpen"
         :role="type === 'error' ? 'alert' : 'status'"
         :class="[type ? 'snackbar--'+type : '']">

        <div class="snackbar__icon" v-if="type === 'error'">
            <svg viewBox="0 0 24 24">
                <use xlink:href="#attention"></use>
            </svg>
        </div>
        <div class="snackbar__icon" v-if="type === 'success'">
            <svg viewBox="0 0 24 24">
                <use xlink:href="#validation"></use>
            </svg>
        </div>
        <div class="snackbar__content">
            <slot>{{ propObj.message }}</slot>
        </div>
        <button type="button" class="snackbar__close" @click="closeSnackbar">
            <svg viewBox="0 0 65 65">
                <use xlink:href="#close"></use>
            </svg>
        </button>
    </div>
</template>

<script>

    export default {
        props: {
            type: {
                default: 'error',
                required: false
            },
            propObj: {
                type: Object,
                required: false,
                default: () => ({
                    isOpen: true,
                    autoDestroy: 3,
                    message: null,
                }),
            },
        },
        methods: {
            closeSnackbar() {
                this.propObj.isOpen = false
                this.$emit('closed', this.propObj.id)
            }
        },
        mounted() {
            if (this.propObj.autoDestroy > 0) {
                let timeout = window.setTimeout(() => {
                    this.propObj.isOpen = false
                    this.$emit('closed', this.propObj.id)
                }, this.propObj.autoDestroy * 1000);
                this._autoDestroyTimeout = timeout;
            }
        },
        beforeDestroy() {
            if (this._autoDestroyTimeout) {
                window.clearTimeout(this._autoDestroyTimeout);
            }
        }
    }
</script>
